import axios from 'axios'
import React, { useState } from 'react'
import Loading from '../../../comps/Loading'
import MainContainer from '../../../comps/MainContainer'
import { API_BASE_URL } from '../../../consts'
import MainLayout from '../../../layouts/MainLayout'
import './EncDec.scss'

const EncDec = () => {
  const [password, setPassword] = useState('')
  const [value, setValue] = useState('')
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const onEncodeOrDecode = async (isDecrypt: boolean) => {
    if (!password || !value) {
      setError('Zadejte heslo i text')
      return
    }
    setError('')
    setIsLoading(true)

    try {
      const data = await axios.get<string>(
        `${API_BASE_URL}/EncDec/${isDecrypt ? 'Decrypt' : 'Encrypt'}?passwd=${encodeURIComponent(
          password
        )}&value=${encodeURIComponent(value)}`
      )
      if (data.status >= 200 && data.status < 300) {
        setResult(data.data)
      } else {
        setError(data.statusText)
      }
    } catch (e) {
      console.log(e)
      setError('Chyba při komunikaci se serverem')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <MainLayout>
      <MainContainer>
        <section id='encdec-wrapper' className='h-100'>
          {isLoading ? (
            <div className='h-100 d-flex flex-column justify-content-center align-items-center'>
              <Loading />
            </div>
          ) : (
            <>
              <h3 className='pb-3 pt-3'>EncDec</h3>

              <div className='row'>
                <div className='mb-3'>
                  <div className='col-12 col-md-6 col-lg-4 form-group row'>
                    <label htmlFor='password' className='col-sm-3 col-form-label'>
                      Heslo:
                    </label>
                    <div className='col-sm-9'>
                      <input
                        type='text'
                        className='form-control'
                        id='inputPassword'
                        placeholder='Heslo...'
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className='mb-3'>
                  <div className='col-12 col-md-6 col-lg-4 form-group row'>
                    <label htmlFor='value' className='col-sm-3 col-form-label'>
                      Text:
                    </label>
                    <div className='col-sm-9'>
                      <input
                        type='text'
                        className='form-control'
                        id='inputValue'
                        placeholder='Text...'
                        value={value}
                        onChange={e => setValue(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className='mb-3'>
                  <div className='col-12 col-md-6 col-lg-4 form-group row'>
                    <label htmlFor='value' className='col-sm-3 col-form-label'>
                      Výsledek:
                    </label>
                    <div className='col-sm-9'>
                      <input
                        readOnly
                        type='text'
                        className='form-control'
                        id='inputValue'
                        value={result}
                      />
                    </div>
                  </div>
                </div>
                <div className='mb-3'>
                  <div className='col-12 col-md-6 col-lg-4 d-flex flex-row justify-content-center'>
                    <button className='btn btn-danger m-2' onClick={() => onEncodeOrDecode(false)}>
                      Encode
                    </button>
                    <button className='btn btn-success m-2' onClick={() => onEncodeOrDecode(true)}>
                      Decode
                    </button>
                  </div>
                </div>

                <div>
                  {error && (
                    <div className='col-12 col-md-6 col-lg-4 d-flex flex-row justify-content-center alert alert-danger'>
                      <h5>{error}</h5>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </section>
      </MainContainer>
    </MainLayout>
  )
}

export default EncDec
